import { isSessionStorageSupported } from '../lib/helpers';

export const SESSION_STORAGE_WORKOS_DOB_ATTEMPT_KEY =
  'workos_dob_attempt_count';
export const SESSION_STORAGE_WORKOS_DOB_HAD_MISMATCH_KEY =
  'workos_dob_had_mismatch';

export function resetWorkosDobAnalyticsState(): void {
  if (!isSessionStorageSupported()) return;
  window.sessionStorage.removeItem(SESSION_STORAGE_WORKOS_DOB_ATTEMPT_KEY);
  window.sessionStorage.removeItem(SESSION_STORAGE_WORKOS_DOB_HAD_MISMATCH_KEY);
}

export function incrementWorkosDobAttempt(): number {
  if (!isSessionStorageSupported()) return 0;
  const current =
    parseInt(
      window.sessionStorage.getItem(SESSION_STORAGE_WORKOS_DOB_ATTEMPT_KEY) ||
        '0',
      10,
    ) || 0;
  const next = current + 1;
  window.sessionStorage.setItem(
    SESSION_STORAGE_WORKOS_DOB_ATTEMPT_KEY,
    String(next),
  );
  return next;
}

export function markWorkosDobMismatch(): void {
  if (!isSessionStorageSupported()) return;
  window.sessionStorage.setItem(
    SESSION_STORAGE_WORKOS_DOB_HAD_MISMATCH_KEY,
    'true',
  );
}

export function getWorkosDobAnalyticsState(): {
  attemptCount: number;
  hadMismatch: boolean;
} {
  if (!isSessionStorageSupported()) {
    return { attemptCount: 0, hadMismatch: false };
  }
  const attemptCount =
    parseInt(
      window.sessionStorage.getItem(SESSION_STORAGE_WORKOS_DOB_ATTEMPT_KEY) ||
        '0',
      10,
    ) || 0;
  const hadMismatch =
    window.sessionStorage.getItem(
      SESSION_STORAGE_WORKOS_DOB_HAD_MISMATCH_KEY,
    ) === 'true';
  return { attemptCount, hadMismatch };
}

export function consumeWorkosDobAnalyticsState(): {
  dob_challenge: true;
  dob_attempt_count: number;
  dob_had_mismatch: boolean;
} {
  const { attemptCount, hadMismatch } = getWorkosDobAnalyticsState();
  resetWorkosDobAnalyticsState();
  return {
    dob_challenge: true,
    dob_attempt_count: attemptCount,
    dob_had_mismatch: hadMismatch,
  };
}
